export const CATEGORIES = {
    UNCATEGORIZED: { label: "Other" },
    UNCHECKED: { label: "Pending" },
    CHECKED: { label: "Done" },
    UNSUGGESTED: { label: "Other" },
    CONDIMENTS_SPICES: { label: "Spices & seasonings" },
    VEGETABLES: { label: "Vegetables" },
    FRUITS: { label: "Fruits" },
    CANNED: { label: "Canned goods" },
    FROZEN: { label: "Frozen foods" },
    DAIRY_EGGS: { label: "Dairy & eggs" },
    CLEANERS: { label: "Cleaning supplies" },
    BAKERY: { label: "Bakery" },
    DELI: { label: "Deli" },
    SNACKS_SWEETS: { label: "Snacks & sweets" },
    PASTA: { label: "Pasta" },
    SAUCES: { label: "Cooking sauces" },
    SEAFOOD: { label: "Fresh seafood" },
    MEAT: { label: "Fresh meat" },
    PERSONAL_CARE: { label: "Personal care" },
    PANTRY: { label: "Pantry staples" },
    GRAINS_SEEDS: { label: "Grains & seeds" },
    BEVERAGES: { label: "Beverages" },
};

export const GROUP_CATEGORIES = {
    COUPLE: { label: "Couple", icon: "bi-heart" },
    HOME: { label: "Home", icon: "bi-house" },
    TRAVEL: { label: "Travel", icon: "bi-airplane" },
    OTHER: { label: "Other", icon: "bi-people" },
};
